module.exports = __webpack_public_path__ + "static/Konoufo.7079085c.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/team/Konoufo.jpg
// module id = 937
// module chunks = 3